export default function ContractDetailIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 24 30"
      fill="none"
    >
      <path
        d="M1.16504 0.5H18.3467V3.96289C18.3467 4.87187 19.1075 5.61033 20.0117 5.61035H23.5V28.8525C23.5 29.195 23.2013 29.5 22.835 29.5H1.16504C0.798706 29.5 0.5 29.195 0.5 28.8525V1.14746C0.5 0.805006 0.798706 0.5 1.16504 0.5Z"
        stroke="#212121"
      />
      <mask id="path-2-inside-1_16924_3839" fill="white">
        <path d="M18.9094 0L24.0002 5V5.71387H19.4875C18.7754 5.71362 18.182 5.13113 18.1819 4.43164V0H18.9094Z" />
      </mask>
      <path
        d="M18.9094 0L24.0002 5V5.71387H19.4875C18.7754 5.71362 18.182 5.13113 18.1819 4.43164V0H18.9094Z"
        fill="white"
      />
      <path
        d="M18.9094 0L19.6101 -0.713442L19.3184 -1H18.9094V0ZM24.0002 5H25.0002V4.5805L24.701 4.28656L24.0002 5ZM24.0002 5.71387V6.71387H25.0002V5.71387H24.0002ZM19.4875 5.71387L19.4872 6.71387H19.4875V5.71387ZM18.1819 4.43164H17.1819V4.43176L18.1819 4.43164ZM18.1819 0V-1H17.1819V0H18.1819ZM18.9094 0L18.2087 0.713442L23.2995 5.71344L24.0002 5L24.701 4.28656L19.6101 -0.713442L18.9094 0ZM24.0002 5H23.0002V5.71387H24.0002H25.0002V5H24.0002ZM24.0002 5.71387V4.71387H19.4875V5.71387V6.71387H24.0002V5.71387ZM19.4875 5.71387L19.4879 4.71387C19.4081 4.71384 19.3293 4.68133 19.2683 4.62144C19.2075 4.5617 19.1819 4.4927 19.1819 4.43152L18.1819 4.43164L17.1819 4.43176C17.182 5.70069 18.2404 6.71343 19.4872 6.71387L19.4875 5.71387ZM18.1819 4.43164H19.1819V0H18.1819H17.1819V4.43164H18.1819ZM18.1819 0V1H18.9094V0V-1H18.1819V0Z"
        fill="#212121"
        mask="url(#path-2-inside-1_16924_3839)"
      />
      <path d="M22 9H2V10.2H22V9Z" fill="#212121" />
      <path d="M22 13H2V14.2H22V13Z" fill="#212121" />
      <path d="M22 17H2V18.2H22V17Z" fill="#212121" />
      <path
        d="M21.5085 22.5332H13.1908V23.7332H21.5085V22.5332Z"
        fill="#212121"
      />
      <path d="M12 5H2V6.2H12V5Z" fill="#212121" />
      <path
        d="M3.97585 21.8672C2.55362 23.4037 2.55362 25.8831 3.97585 27.4196C5.39807 28.9561 7.69302 28.9561 9.11524 27.4196C10.5375 25.8831 10.5375 23.4037 9.11524 21.8672C7.69302 20.3307 5.39807 20.3307 3.97585 21.8672ZM4.23443 22.1466C5.33342 20.9593 7.04655 20.8196 8.30716 21.6926L7.78999 22.2514C6.82029 21.6577 5.55969 21.7974 4.71928 22.6704C3.87888 23.5783 3.74958 24.9402 4.3314 25.9879L3.81423 26.5466C3.00615 25.1847 3.13544 23.3339 4.23443 22.1466ZM4.62231 25.7085C4.20211 24.8355 4.3314 23.718 5.01019 23.0196C5.68898 22.2863 6.691 22.1466 7.49908 22.6006L4.62231 25.7085ZM8.43645 23.5783C8.85666 24.4514 8.72736 25.5688 8.04857 26.2672C7.36979 27.0006 6.36777 27.1402 5.55969 26.6863L8.43645 23.5783ZM8.82433 27.1053C7.72534 28.2926 6.01221 28.4323 4.7516 27.5593L5.26878 27.0006C6.23847 27.5942 7.49908 27.4545 8.33948 26.5815C9.17989 25.6736 9.30918 24.3117 8.72736 23.2641L9.24453 22.7053C10.0849 24.0672 9.92332 25.918 8.82433 27.1053Z"
        fill="#212121"
      />
    </svg>
  );
}
